import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 19px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Columns = styled.div`
  display: flex;
`

export const Column = styled.div`
  width: 416px;
`
